/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckDeclarationItem, PaxCheckDeclarationItemFromJSONTyped, PaxCheckDeclarationItemToJSON } from "./PaxCheckDeclarationItem";
import { PaxCheckHaveDocumentQuestion, PaxCheckHaveDocumentQuestionFromJSONTyped, PaxCheckHaveDocumentQuestionToJSON } from "./PaxCheckHaveDocumentQuestion";
import { PaxCheckPickFromListQuestion, PaxCheckPickFromListQuestionFromJSONTyped, PaxCheckPickFromListQuestionToJSON } from "./PaxCheckPickFromListQuestion";


/**
 * @type PaxCheckQuestion
 * 
 * @export
 */
export type PaxCheckQuestion = { type: 'declaration-item' } & PaxCheckDeclarationItem | { type: 'have-document-question' } & PaxCheckHaveDocumentQuestion | { type: 'pick-from-list-question' } & PaxCheckPickFromListQuestion;

export function PaxCheckQuestionFromJSON(json: any): PaxCheckQuestion {
    return PaxCheckQuestionFromJSONTyped(json, false);
}

export function PaxCheckQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckQuestion {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'declaration-item':
            return Object.assign({}, PaxCheckDeclarationItemFromJSONTyped(json, true), { type: 'declaration-item' } as const);
        case 'have-document-question':
            return Object.assign({}, PaxCheckHaveDocumentQuestionFromJSONTyped(json, true), { type: 'have-document-question' } as const);
        case 'pick-from-list-question':
            return Object.assign({}, PaxCheckPickFromListQuestionFromJSONTyped(json, true), { type: 'pick-from-list-question' } as const);
        default:
            return json;
    }
}

export function PaxCheckQuestionToJSON(json: any): any {
    return PaxCheckQuestionToJSONTyped(json, false);
}

export function PaxCheckQuestionToJSONTyped(value?: PaxCheckQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'declaration-item':
            return Object.assign({}, PaxCheckDeclarationItemToJSON(value), { type: 'declaration-item' } as const);
        case 'have-document-question':
            return Object.assign({}, PaxCheckHaveDocumentQuestionToJSON(value), { type: 'have-document-question' } as const);
        case 'pick-from-list-question':
            return Object.assign({}, PaxCheckPickFromListQuestionToJSON(value), { type: 'pick-from-list-question' } as const);
        default:
            return value;
    }
}

